import React from 'react';
import { Control, Controller } from 'react-hook-form';

import { Description, Label } from '../ui/catalyst/fieldset';
import { Switch, SwitchField } from '../ui/catalyst/switch';
import { FormSection } from './FormSection';
import { CreateMatterFormValues, UpdateMatterFormValues } from './types';

interface ClientContactSectionProps {
  control: Control<CreateMatterFormValues | UpdateMatterFormValues>;
  errors: any;
  isLoading: boolean;
}

export const ClientContactSection: React.FC<ClientContactSectionProps> = ({
  control,
  errors,
  isLoading,
}) => {
  return (
    <FormSection
      title="Client Contact"
      description="Communication policy for this matter"
    >
      <div className="space-y-6">
        <Controller
          name="contact_client_directly"
          control={control}
          defaultValue
          render={({ field: { value, onChange } }) => (
            <SwitchField>
              <div className="flex items-center justify-between">
                <div>
                  <Label htmlFor="contact_client_directly">
                    Contact Client Directly
                  </Label>
                  <Description>
                    {value
                      ? 'Finch staff may contact the client directly'
                      : 'Only the firm will communicate with the client'}
                  </Description>
                </div>
                <Switch
                  id="contact_client_directly"
                  checked={value}
                  onChange={onChange}
                  disabled={isLoading}
                  color="indigo"
                />
              </div>
            </SwitchField>
          )}
        />
      </div>
    </FormSection>
  );
};
